import { render } from "./signup-form.vue?vue&type=template&id=9446fc1e"
import script from "./signup-form.vue?vue&type=script&lang=js"
export * from "./signup-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__